import { Box, Text, Card, Loader, MarketingPageLayout, MarketingPageLayoutContent, Page, WixDesignSystemProvider, Image, Button, Notification } from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import Goal from './goal.png';
import { ReactTagManager } from 'react-gtm-ts';
import React, { useEffect } from 'react';
import * as Icons from '@wix/wix-ui-icons-common';
import { useTranslation } from "react-i18next";
import { track } from "./analytics";

const WIX_APP_ID = "6f64d1e5-5630-4542-a499-d70a971c6c85";
const tagManagerArgs = { code: 'GTM-WZQPMC7' };

function App() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get('token');
  const instance = new URLSearchParams(window.location.search).get('instance');
  const [isUpgraded, setIsUpgraded] = React.useState(false);

  const [instanceData, setInstanceData] = React.useState({
    instance: { isFree: true, availablePlans: [], instanceId: "" }
  });

  const isFree = instanceData?.instance?.isFree !== false;
  const [isUpgradeBannerOpen, setIsUpgradeBannerOpen] = React.useState<boolean>(isFree);

  const BASE_URL = `https://wix.certifiedcode.io/goal/_functions`;

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    setInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: { "Authorization": instance || "" }
    })
      .then(response => response.json())
      .then(data => {
        setInstanceData(data);
        setIsUpgraded(data.instance.isFree === false);
        setIsUpgradeBannerOpen(data.instance.isFree !== false);
      })
      .catch(() => { });
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;
  const reviewUrl = `https://bridget.reviews.certifiedcode.us/${WIX_APP_ID}${window.location.search}`;

  if (token) {
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=${WIX_APP_ID}&redirectUrl=https://wix.certifiedcode.io/goal/_functions/@certifiedcode/base-backend/auth`;
    return <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Page height='100vh'>
        <Page.Content>
          <Box height={"90vh"} direction="vertical" verticalAlign="middle">
            <Loader text={t('loading')} />
          </Box>
        </Page.Content>
      </Page></WixDesignSystemProvider>;
  }

  return <WixDesignSystemProvider features={{ newColorsBranding: true }}>
    <Notification theme="premium" show={isUpgradeBannerOpen} type={"sticky"}>
      <Notification.TextLabel>
        {t('upgradeMessage')}
      </Notification.TextLabel>
      <Notification.ActionButton
        type="textLink"
        as="a"
        href={upgradeUrl}
        target="_blank"
        onClick={() => track("upgrade_clicked", { source: "banner" })}
      >
        {t('upgrade-button')}
      </Notification.ActionButton>
      <Notification.CloseButton
        onClick={() => setIsUpgradeBannerOpen(false)}
      />
    </Notification>
    <Card>
      <MarketingPageLayout
        removeImageHorizontalPadding
        removeImageVerticalPadding
        content={
          <Box height="840px" verticalAlign="middle">
            <MarketingPageLayoutContent
              title={t('goal-title')}
              content={t('goal-content')}
              actions={<Box direction="vertical" gap="SP2">
                <Button skin="premium" disabled={isUpgraded} prefixIcon={<Icons.PremiumFilled />}
                  as="a" href={upgradeUrl} target="_blank"
                  onClick={() => track("upgrade_clicked", { source: "cta" })}
                >{t('goal-upgrade-button')}</Button>
                <Button skin='inverted' prefixIcon={<Icons.Reviews />} as='a' href={reviewUrl} target='_blank'>{t('rate-button')}</Button>
              </Box>}
            />
          </Box>
        }
        image={<Image borderRadius={0} src={Goal} />}
      />
    </Card>
  </WixDesignSystemProvider>;
}

export default App;
